/**
 * Utility to track if language preference modal has been shown to the user
 * This prevents showing the modal multiple times across browsing sessions
 */

const STORAGE_KEY = "amber_language_prompt_shown";

/**
 * Check if language prompt has been shown to the user
 */
export const hasShownLanguagePrompt = (): boolean => {
  if (typeof localStorage === "undefined") return false;

  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    console.warn("Failed to check language prompt persistence:", error);
    return false;
  }
};

/**
 * Mark that language prompt has been shown to the user
 */
export const markLanguagePromptShown = (): void => {
  if (typeof localStorage === "undefined") return;

  try {
    localStorage.setItem(STORAGE_KEY, "true");
  } catch (error) {
    console.warn("Failed to mark language prompt persistence:", error);
  }
};

/**
 * Clear the language prompt flag
 * Useful for testing or when user explicitly changes language
 */
export const clearLanguagePromptSession = (): void => {
  if (typeof localStorage === "undefined") return;

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn("Failed to clear language prompt persistence:", error);
  }
};
